import useIsPlanView from '@editor/hooks/useIsPlanView'
import { useCommentFilterStore } from '@editorStores'

/**
 * Whether the scene currently previews the stiffening plan (Planansicht with "Aussteifungsplan").
 * The shared floorplan rendering switches to the stiffening PDF's styles (wall footprints, wall
 * assembly labels, stiffening segments) on this — the plan view itself only chooses the plan.
 */
const useIsStiffeningPlanPreview = (): boolean => {
  const isPlanView = useIsPlanView()
  const selectedPlan = useCommentFilterStore(state => state.selectedPlan)
  return isPlanView && selectedPlan === 'stiffeningPlan'
}

export default useIsStiffeningPlanPreview
